import { render, staticRenderFns } from "./RulesText.vue?vue&type=template&id=2e3521b4&scoped=true"
import script from "./RulesText.vue?vue&type=script&lang=ts"
export * from "./RulesText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3521b4",
  null
  
)

export default component.exports